import { Component } from '@angular/core';

import * as _ from 'lodash';

import { BaseComponent } from '../_base.component';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-radio',
  templateUrl: './radio.component.html',
  host: {
    class: 'uex-input-radio'
  }
})
export class InputRadioComponent extends BaseComponent<any> {
  public isActiveOption(option_value: any): boolean {
    return _.isEqual(this.value, option_value);
  }
}
